import { createContext } from 'react';

import { AccountError } from '@legacy/AccountError';
import { User } from '@legacy/User';

export type ILoginVariables = {
  email: string;
  password: string;
};
export type ILogin = (
  option: ILoginVariables,
) => Promise<{ user: User | null; errors: AccountError[] }>;

export interface IAuthContext {
  loading: boolean;
  token: string | null;
  user: User | null;
  isLoggedIn: boolean;
  logout(): void;
  login: ILogin;
  loginByToken(token: string): Promise<void>;
}

const defaultContext = {
  isLoggedIn: false,
  loading: false,
  /* eslint-disable */
  login: async (options: ILoginVariables) => ({ errors: [], user: null }),
  loginByToken: async (token: string) => undefined,
  logout: () => {},
  /* eslint-enable */
  token: null,
  user: null,
};

export const AuthContext = createContext<IAuthContext>(defaultContext);
AuthContext.displayName = 'AuthContext';
